/* RG Enterprises — site front-end JS */

// PDP gallery: click a thumb to swap the hero image
(function () {
  const hero = document.getElementById('pdp-hero-img');
  if (!hero) return;
  const thumbs = document.querySelectorAll('.pdp__thumb');
  thumbs.forEach((t) => {
    t.addEventListener('click', (e) => {
      e.preventDefault();
      const src = t.getAttribute('data-src');
      if (!src) return;
      hero.src = src;
      thumbs.forEach((x) => x.classList.remove('pdp__thumb--active'));
      t.classList.add('pdp__thumb--active');
    });
  });
})();

// Sticky-nav scrolled shadow
(function () {
  const nav = document.getElementById('nav');
  if (!nav) return;
  const onScroll = () => {
    if (window.scrollY > 20) nav.classList.add('nav--scrolled');
    else nav.classList.remove('nav--scrolled');
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
})();

// Close mobile menu when clicking a link (future-proofing for mobile expansion)
document.querySelectorAll('.nav__links a').forEach(a => {
  a.addEventListener('click', () => document.body.classList.remove('menu-open'));
});

// Hero slider: fade/cross-dissolve between full-bleed images
(function () {
  const track = document.querySelector('[data-slider-track]');
  if (!track) return;
  const slides = Array.from(track.querySelectorAll('.hero__slide'));
  const dots   = Array.from(document.querySelectorAll('[data-slider-dots] .hero__dot'));
  const prev   = document.querySelector('[data-slider-prev]');
  const next   = document.querySelector('[data-slider-next]');
  if (slides.length < 2) return;

  let idx = 0;
  let timer = null;
  const DURATION = 6000;

  function goTo(n) {
    idx = (n + slides.length) % slides.length;
    slides.forEach((s, i) => {
      s.classList.toggle('is-active', i === idx);
      s.setAttribute('aria-hidden', i === idx ? 'false' : 'true');
    });
    dots.forEach((d, i) => {
      d.classList.toggle('is-active', i === idx);
      d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
    });
  }

  function start() {
    stop();
    timer = setInterval(() => goTo(idx + 1), DURATION);
  }
  function stop() {
    if (timer) { clearInterval(timer); timer = null; }
  }

  prev && prev.addEventListener('click', () => { goTo(idx - 1); start(); });
  next && next.addEventListener('click', () => { goTo(idx + 1); start(); });
  dots.forEach((d, i) => d.addEventListener('click', () => { goTo(i); start(); }));

  // Pause on hover (desktop) + when tab is hidden
  const slider = document.querySelector('.hero__slider');
  if (slider) {
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
  }
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stop(); else start();
  });

  // Keyboard
  document.addEventListener('keydown', (e) => {
    // Only when hero is roughly in view (top of page)
    if (window.scrollY > (slider ? slider.offsetHeight : 600)) return;
    if (e.key === 'ArrowLeft')  { goTo(idx - 1); start(); }
    if (e.key === 'ArrowRight') { goTo(idx + 1); start(); }
  });

  start();
})();
